import { Loader } from '@googlemaps/js-api-loader';

/**
 * Google Map
 * ======================================
 * <div class="map js-map" data-lat="49.84306953594377" data-lng="14.525088870187364"></div>
 * https://developers.google.com/maps/documentation/javascript/tutorial
 *
 */

 // const markers = [
//   {"title": "Rudná", "lat": 49.8037633, "lng": 15.4749126},
//   {"title": "Benešov", "lat": 49.8537633, "lng": 15.7749126, "large": true},
//   {"title": "Kladno", "lat": 49.8837633, "lng": 15.3749126}
// ]

const API_KEY = 'AIzaSyA-ilfWFRTEtDJx3dXnfJvwnikov8OOWnc'
const WIDGET = '.js-map'

class Map {
	constructor() {
    this.element = document.querySelector(WIDGET)

    if (!this.element) {
			return false
    }

    this.lat = parseFloat(this.element.getAttribute('data-lat'))
    this.lng = parseFloat(this.element.getAttribute('data-lng'))
    this.marker = 'images/marker.svg'
    this.mapOptions = {
			zoom: parseFloat(this.element.getAttribute('data-zoom')),
			center: { lat: this.lat, lng: this.lng },
			disableDefaultUI: true,
			zoomControl: true,
			scrollwheel: false
    }

		if (!this.lat || !this.lng) {
			return false
    }

    const loader = new Loader({
      apiKey: API_KEY,
      version: "weekly"
    });

    loader.load().then(() => {
      this.initMap()
    })
    .catch(e => {
      console.log('Mapu nelze načíst.', e)
    });
  }

  initMap = () => {
    const map = new google.maps.Map(this.element, this.mapOptions)

    /**
		* Styled map
		*/
		const styledMapType = new google.maps.StyledMapType(this.getStyles())

		// map.mapTypes.set('customMapStyle', styledMapType)
		// map.setMapTypeId('customMapStyle')

		const iconSvg = {
			url: '/app/themes/ipress/build/'+this.marker,
			scaledSize: new google.maps.Size(179, 46)
		}

		const iconSvgLarge = {
			url: '/app/themes/ipress/build/'+this.marker,
			scaledSize: new google.maps.Size(33, 47)
		}

		if (typeof markers !== 'undefined') {
			markers.forEach(item => {
				const marker = new google.maps.Marker({
					icon: item.large ? iconSvgLarge : iconSvg,
					optimized: false,
					title: item.title,
					position: { lat: item.lat, lng: item.lng }
				})
				marker.setMap(map)
			})
		} else {
      const marker = new google.maps.Marker({
        icon: iconSvg,
        optimized: false,
        position: { lat: this.lat, lng: this.lng }
      })
      marker.setMap(map)
    }
  }

  // https://mapstyle.withgoogle.com/
	getStyles = () => {
    return [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#c9c9c9"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ]
	}
}

new Map()

